import React from 'react';
import PropTypes from 'prop-types';

// FIXME This component should be deprecated after removing all instances
// React has this feature since the beginning https://reactjs.org/docs/conditional-rendering.html

export const withConditional = Component => {
  class Conditional extends React.Component {
    render() {
      const { condition, ...restProps } = this.props;
      return condition ? <Component {...restProps} /> : null;
    }
  }

  Conditional.propTypes = {
    condition: PropTypes.bool,
  };
  return Conditional;
};
